import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
export function useStore() {
    const wrap = useContext(MobXProviderContext);
    return wrap.rootStore;
}
